import { ComponentFactoryResolver, ComponentRef, Directive, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';
import { HighlighterComponent } from 'src/app/main/dashboard/buyer/highlighter/highlighter.component';
import { UserService } from 'src/app/views/users/services/user.service';


@Directive({
  selector: '[appBlur]'
})
export class BlurDirective {
  currentUser: any;
  userDetails: any;
  private componentRef: ComponentRef<HighlighterComponent> | null = null;
  private routerSubscription: Subscription | null = null;
  isLoading = false;
  
  constructor(
    private el: ElementRef, 
    private renderer: Renderer2, 
    private userService: UserService, 
    private authService: AuthService,
    private router: Router,
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver
  ) {
    this.currentUser = this.authService.currentUserValue;
    this.subscribeToRouterEvents();
    this.getUser();
  }

  getUser(){
    if(this.isLoading == true){
      return;
    }
    this.isLoading = true;
    this.userService.getUserInfo({}).subscribe((res: any) => {
      this.isLoading = false;
      this.userDetails = res.result[0];
      if(!this.userDetails.isApproved){
       this.checkAndApplyBlurWithOutServerCall();
      }
    });
  }


  private subscribeToRouterEvents() {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if(!this.userDetails){
          this.getUser();
          return
        }
        this.checkAndApplyBlurWithOutServerCall();
      });
  }

  // private checkAndApplyBlur() {
  //   const excludedUrls = ['/dashboard/seller/edit-profile?edit=1', '/dashboard/seller/edit-profile','/dashboard/buyer/edit-profile']; // Add URLs where blur should not be applied
  //   const currentUrl = this.router.url;

  //   if (excludedUrls.includes(currentUrl)) {
  //     this.removeBlurEffect();
  //     this.appendHighlighter();
  //   } else {
  //     // Otherwise, apply the blur effect based on user approval
  //     this.highlightingWithBlur();
  //   }
  // }

  private removeBlurEffect() {
    // Reset styles
    this.renderer.removeStyle(this.el.nativeElement, 'filter');
    this.renderer.removeStyle(this.el.nativeElement, 'pointer-events');

    // Remove highlighter component if present
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

 
  highlightingWithBlur() {
  
        this.renderer.setStyle(this.el.nativeElement, 'filter', 'blur(2px)');
        this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
        this.appendHighlighter();
   
  }

  checkAndApplyBlurWithOutServerCall() {
    const excludedUrls = ['/dashboard/seller/edit-profile?edit=1', '/dashboard/buyer/edit-profile']; // Add URLs where blur should not be applied
    const currentUrl = this.router.url;
    if (this.userDetails?.isApproved == false && [2,3,'2','3'].includes(this.userDetails?.userType)) {
      if (excludedUrls.includes(currentUrl)) {
        this.removeBlurEffect();
        this.appendHighlighter();
      } else {
        this.renderer.setStyle(this.el.nativeElement, 'filter', 'blur(2px)');
        this.renderer.setStyle(this.el.nativeElement, 'pointer-events', 'none');
        this.appendHighlighter();
      }
    }else{
      this.removeBlurEffect();
    }
  }

  private appendHighlighter() {
    if (this.componentRef) return; // Avoid duplicate components

    const factory = this.resolver.resolveComponentFactory(HighlighterComponent);
    this.componentRef = this.viewContainerRef.createComponent(factory);
  }

}
